<template>
  <v-navigation-drawer disable-resize-watcher permanent app disable-route-watcher class="app-navigation">
    <v-list nav>
      <div class="separate--after hide-sm">
        <v-list-item class="app-navigation__logo">
          <v-list-item-content d-flex>
            <logo />
          </v-list-item-content>
        </v-list-item>
      </div>

      <v-list-item color="primary" link class="hide-desktop" :to="{ name: 'home' }">
        <v-list-item-icon>
          <v-icon>mdi-home</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Strona główna</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-for="item in items" :key="item.title" color="primary" link :to="{ name: item.routeName }">
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        v-if="!currentApplication && (!card || isExpiring || isInactive)"
        color="primary"
        link
        :to="{ name: 'application' }"
      >
        <v-list-item-icon>
          <v-icon>mdi-file-document</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ submitText }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item color="primary" link class="hide-sm" :to="{ name: 'profileConfig' }">
        <v-list-item-icon>
          <v-icon>mdi-cog</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Ustawienia</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item tag="a" href="#" class="logoutButton hide-sm w-100" @click.prevent="toggleLogoutConfirm">
        <v-list-item-icon>
          <v-icon>mdi-power</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Wyloguj</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-bottom-sheet v-model="dialog">
        <template v-slot:activator="{ on }">
          <v-btn elevation="0" class="hide-desktop nav-settings-mobile" v-on="on">
            <v-icon>mdi-cog</v-icon>
          </v-btn>
        </template>

        <v-card class="bottom-dialog-mobile">
          <div class="v-card-h1">Ustawienia</div>

          <v-list>
            <v-list-item link :to="{ name: 'profileConfig' }" @click="dialog = false">
              <v-list-item-action>
                <v-icon>mdi-account-edit</v-icon>
              </v-list-item-action>

              <v-list-item-title>Edycja profilu</v-list-item-title>
            </v-list-item>

            <v-list-item tag="a" href="#" @click.prevent="toggleLogoutConfirm">
              <v-list-item-icon>
                <v-icon>mdi-power</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Wyloguj</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-bottom-sheet>
    </v-list>

    <material-dialog
      title="Potwierdź wylogowanie"
      text="Czy na pewno chcesz się wylogować?"
      :show="showLogoutConfirmDialog"
      @close="toggleLogoutConfirm"
      @confirm="logout"
    />

    <div
      v-if="!currentApplication && (!card || isExpiring || isInactive)"
      class="separate--before app-navigation__card-proposition hide-sm"
    >
      <v-list-item>
        <v-list-item-content d-flex>
          <p>{{ submitAboveText }}</p>

          <v-btn
            depressed
            large
            block
            type="submit"
            color="primary"
            style="margin: auto;"
            :to="{ name: 'application' }"
          >
            {{ submitText }}
          </v-btn>
        </v-list-item-content>
      </v-list-item>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { dateFilter } from '@witkac/kartamiejska-shared';

import MaterialDialog from '@/components/material/Dialog';
import Logo from '@/components/material/Logo';
import { cardMixin } from '@/mixins/cardMixin';
import { routing } from '@/utils/mainRouting';

// @vuese
// Menu boczne
// @group Drawer
export default {
  components: { Logo, MaterialDialog },
  mixins: [cardMixin],
  props: {
    // Czy pokazać boczne menu
    drawer: {
      type: Boolean,
      required: true,
      default: null
    }
  },

  data: () => ({
    dialog: null,
    localDrawer: null,
    group: null,
    showLogoutConfirmDialog: false,
    items: routing()
  }),
  computed: {
    submitText() {
      if (this.card && !this.isInactive) {
        return 'Przedłuż ważność karty';
      }
      return 'Złóż wniosek o kartę';
    },
    submitAboveText() {
      if (this.card) {
        if (this.hasEndDate && !this.isInactive) {
          return `Ważna do ${dateFilter(this.card.endDate)}`;
        }
        return '';
      }
      return 'Wygląda na to, że nie posiadasz aktywnej karty mieszkańca.';
    }
  },
  watch: {
    drawer() {
      this.localDrawer = this.drawer;
    },
    localDrawer() {
      this.$emit('drawer', this.localDrawer);
    }
  },
  mounted() {
    this.localDrawer = this.drawer;
  },
  methods: {
    // @vuese
    // Pokazywanie/Ukrywanie potwierdzenia wylogowania
    toggleLogoutConfirm() {
      this.showLogoutConfirmDialog = !this.showLogoutConfirmDialog;
    },
    // @vuese
    // Metoda do wylogowywania użytkownika
    // Czyści session storage
    logout() {
      this.$store.dispatch('auth/unauthorize').then(() => this.$router.push({ name: 'login' }));
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
.v-icon {
  color: $color-border !important;
}
.v-list-item--active .v-list-item__title {
  color: $color-active;
}

.v-list-item--active .v-icon {
  color: $color-active !important;
}
</style>
